<div class="layout">
  <!-- LEFT: maroon brand panel -->
  <div class="brand-panel">
    <div class="anim d3">
      <h1 class="headline">A new model for<br/><em>creative execution.</em></h1>
      <p class="lede">Structured by AI, delivered with human expertise — built on a century of Mahatta's production legacy. We solve the beginning, where most projects fail before execution begins.</p>
    </div>

    <div style="height: 40px;"></div>

    <div class="anim d4">
      <p class="framework-label">THE FOUR-PART PLATFORM</p>
      <div class="stage-grid">
        <div class="stage-card">
          <div class="stage-num">01</div>
          <div class="stage-name">Scope</div>
          <div class="stage-desc">AI-assisted project planning</div>
        </div>
        <div class="stage-card">
          <div class="stage-num">02</div>
          <div class="stage-name">Source</div>
          <div class="stage-desc">AI-assisted partner matching</div>
        </div>
        <div class="stage-card">
          <div class="stage-num">03</div>
          <div class="stage-name">Bid</div>
          <div class="stage-desc">Structured bid comparison</div>
        </div>
        <div class="stage-card">
          <div class="stage-num">04</div>
          <div class="stage-name">Execute</div>
          <div class="stage-desc">End-to-end project delivery</div>
        </div>
      </div>
    </div>

    <div class="anim d5 footer-row">
      <div>
        <div class="stat-label" style="margin-top: 0;">BY MAHATTA</div>
        <div class="footer-line"><span class="footer-line-animated">Serving Creativity since 1915</span></div>
      </div>
    </div>
  </div>

  <!-- RIGHT: panel with logo + auth -->
  <div class="action-panel">
    <div class="panel-body">
      <div class="anim d2 center" style="margin-bottom: 36px; text-align: center;">
        <img src="../../../../assets/images/logos/studioip logo black.png" alt="StudioIP" style="height: 32px; width: auto; display: inline-block;" />
        <div style="font-size: 10px; letter-spacing: 0.4px; color: var(--text-tertiary); margin-top: 10px;">India's 1<sup>st</sup> AI-assisted creative execution platform</div>
      </div>

      <!-- LOGIN (Unified Email/Phone OTP + Password) -->
      <div>
        <div class="back-link back-link-offset" routerLink="/customers/signup">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left"
            viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
          </svg> Back
        </div>
        <p class="eyebrow">EXISTING CLIENT</p>
        <h2 class="panel-h2" style="margin-bottom: 22px;">Log in to <em>StudioIP</em></h2>

        <button class="secondary-btn" style="margin-bottom: 10px;" (click)="signInWithGoogle()" [disabled]="isLoading">
          <svg width="15" height="15" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.4-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.6l6.2 5.2c.4-.4 6.6-4.8 6.6-14.8 0-1.3-.1-2.4-.4-3.5z"/>
          </svg>
          Log in with Google
        </button>

        <div class="divider"><hr/><span>OR</span><hr/></div>

        <!-- Login Method Toggle: OTP vs Password -->
        <div class="method-toggle">
          <button class="method-tab" [class.on]="loginMode === 'otp'" (click)="setLoginMode('otp')">
            <i class="ti ti-mail" style="font-size: 12px; vertical-align: -1px; margin-right: 3px;"></i>OTP Login
          </button>
          <button class="method-tab" [class.on]="loginMode === 'password'" (click)="setLoginMode('password')">
            <i class="ti ti-lock" style="font-size: 12px; vertical-align: -1px; margin-right: 3px;"></i>Email & Password
          </button>
        </div>

        <!-- OTP LOGIN (Unified Email/Phone) -->
        <ng-container *ngIf="loginMode === 'otp'">
          <ng-container *ngIf="otpStep === 'identifier'">
            <p class="small-note" style="margin-bottom: 12px;">Enter your email or phone number to LogIn.</p>
            <input type="text" class="auth-input" [(ngModel)]="identifier"
                   (ngModelChange)="onIdentifierChange()"
                   (blur)="validateIdentifier()"
                   (keyup.enter)="isValidIdentifier && !isLoading && sendOtp()"
                   placeholder="name@company.com or 9876543210" style="margin-bottom: 10px;" />
            <button class="primary-btn" (click)="sendOtp()" [disabled]="!isValidIdentifier || isLoading">
              Continue <i class="ti ti-arrow-right" style="font-size: 14px;"></i>
            </button>
          </ng-container>

          <ng-container *ngIf="otpStep === 'otp'">
            <div class="back-link" (click)="goBackToIdentifier()">
              <i class="ti ti-arrow-left" style="font-size: 13px;"></i> Change {{ otpIsEmail ? 'email' : 'number' }}
            </div>
            <p class="small-note" style="margin-bottom: 16px;">
              We sent a 6-digit code to <strong>{{ maskedIdentifier }}</strong> via {{ otpIsEmail ? 'Email' : 'SMS' }}.
            </p>
            <input type="text" class="auth-input" [(ngModel)]="otpCode" placeholder="------" maxlength="6"
                   (input)="formatOtpInput($event)"
                   (keyup.enter)="otpCode.length === 6 && !isLoading && verifyOtp()"
                   style="margin-bottom: 10px; text-align: center; letter-spacing: 4px;" />
            <button class="primary-btn" (click)="verifyOtp()" [disabled]="otpCode.length !== 6 || isLoading">
              Verify & Sign In <i class="ti ti-arrow-right" style="font-size: 14px;"></i>
            </button>
            <div class="resend-row" style="margin-top: 14px; text-align: center;">
              <button type="button" class="resend-btn" [disabled]="otpTimer > 0 || isLoading" (click)="resendOtp()">
                <span *ngIf="otpTimer > 0">Resend OTP in {{ otpTimer }}s</span>
                <span *ngIf="otpTimer === 0">Resend OTP</span>
              </button>
            </div>
          </ng-container>
        </ng-container>

        <!-- EMAIL + PASSWORD LOGIN -->
        <form *ngIf="loginMode === 'password'" [formGroup]="loginForm" (ngSubmit)="onPasswordSubmit()">
          <input type="email" formControlName="email" class="auth-input" placeholder="name@company.com" style="margin-bottom: 4px;" />
          <div class="field-error" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" style="justify-content: flex-start; margin-bottom: 8px;">
            <i class="ti ti-alert-circle" style="width: 14px; height: 14px;"></i>
            <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required.</span>
            <span *ngIf="loginForm.get('email')?.errors?.['email']">Please enter a valid email address.</span>
          </div>
          <input type="password" formControlName="password" class="auth-input" placeholder="Password" style="margin-bottom: 4px;" />
          <div class="field-error" *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.errors?.['required']" style="justify-content: flex-start; margin-bottom: 6px;">
            <i class="ti ti-alert-circle" style="width: 14px; height: 14px;"></i>
            Password is required.
          </div>
          <div style="text-align: right; margin-bottom: 12px;">
            <span style="font-size: 11px; color: var(--maroon); cursor: pointer;" routerLink="/customer/forgot-password">Forgot password?</span>
          </div>
          <button class="primary-btn" type="submit" [disabled]="loginForm.invalid || isLoading">
            Sign In <i class="ti ti-arrow-right" style="font-size: 14px;"></i>
          </button>
        </form>

        <div class="field-error" *ngIf="identifierError" style="margin-top: 12px;">
          <i class="ti ti-alert-circle" style="width: 14px; height: 14px;"></i>
          {{ identifierError }}
        </div>
        <div class="field-error" *ngIf="otpError" style="margin-top: 12px;">
          <i class="ti ti-alert-circle" style="width: 14px; height: 14px;"></i>
          {{ otpError }}
        </div>

        <p class="small-note">New to StudioIP? <span routerLink="/customers/signup" [queryParams]="{ start: 'signup' }">Scope your first project</span></p>
      </div>
    </div>
  </div>
</div>
